/**
 * Get value from HTML meta tag
 */
function getMetaValue(key) {
  let value = '';
  const node = document.querySelector(`meta[property=${key}]`);
  if (node !== null) {
    value = node.getAttribute('content');
  }
  return value;
}

export default { getMetaValue };



// WEBPACK FOOTER //
// ./src/config.loader.js